<template>
  <div id="ShipDoc">
    <div class="row" v-if="page_data.length > 0">
      <h1>退/換貨政策</h1>
      <div v-html="page_data[0].content"></div>
    </div>
  </div>
</template>

<script>
import qs from "qs";
export default {
  name: "ShipDoc",
  data() {
    return {
      page_data: [],
      meta_content: "",
    };
  },
  methods: {
    async GetDocData() {
      let result = await this.SendPostData(
        process.env.VUE_APP_BASE_API + "web_edit/get_common_column.php",
        qs.stringify({ column_array: ["shop_doc"] })
      );
      if (result != "error") {
        this.page_data = JSON.parse(result.data);
        this.$nextTick(() => {
          window.prerenderReady = true;
        });
      }
    },
  },
  created() {
    this.GetDocData();
  },
  metaInfo() {
    return {
      title: "退/換貨政策｜銳仕技研｜Rerace Performance",
      meta: [
        {
          property: "og:description",
          content: "有任何訂單相關的問題歡迎來訊來電與我們聯絡",
          vmid: "og:description",
        },
        {
          property: "twitter:description",
          content: "有任何訂單相關的問題歡迎來訊來電與我們聯絡",
          vmid: "twitter:description",
        },
        {
          property: "description",
          content: "有任何訂單相關的問題歡迎來訊來電與我們聯絡",
          vmid: "description",
        },
        {
          property: "og:image",
          content: "https://rerace.yongxin-design.com/img/share/index.jpg",
          vmid: "og:image",
        },
        {
          property: "apple-mobile-web-app-title",
          content: "退/換貨政策｜銳仕技研｜Rerace Performance",
          vmid: "apple-mobile-web-app-title",
        },
        {
          property: "application-name",
          content: "退/換貨政策｜銳仕技研｜Rerace Performance",
          vmid: "application-name",
        },
        {
          property: "og:site_name",
          content: "退/換貨政策｜銳仕技研｜Rerace Performance",
          vmid: "og:site_name",
        },
        {
          property: "og:type",
          content: "website",
          vmid: "og:type",
        },
        {
          property: "og:locale",
          content: "zh_tw",
          vmid: "og:locale",
        },
      ],
    };
  },
};
</script>
